module.exports = __webpack_public_path__ + "static/media/icon-rounded-outline-info.9f8ea8f2.svg";